import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-reset",
  "use": "icon-reset-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-reset\">\n  <path fill=\"currentColor\" d=\"M9.962 15.425a5.483 5.483 0 01-5.433-4.475h2.292l-3.16-3.796L.5 10.951h2.432c.502 3.431 3.466 6.053 7.029 6.021a7.14 7.14 0 005.026-2.047l-1.117-1.09a5.568 5.568 0 01-3.908 1.59zM16.991 9.049c-.502-3.431-3.465-6.053-7.029-6.021a7.138 7.138 0 00-5.027 2.047l1.117 1.09a5.55 5.55 0 013.91-1.59 5.481 5.481 0 015.432 4.475h-2.232l3.169 4.423L19.5 9.049h-2.509z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol